import {
  MOTION_SPEED_SLIDER_MAX,
  MOTION_SPEED_SLIDER_MIN,
  clampMotionRate,
  formatMotionSpeedLabel,
  motionRateFromSlider,
  motionSliderFromRate,
} from './motionSpeedScale';

export function vfxParamUsesFineSpeedSlider(schema) {
  if (!schema) return false;
  const key = String(schema.key || '').toLowerCase();
  const label = String(schema.label || '').toLowerCase();
  return key === 'speed' || label.includes('drift speed') || label.includes('speed');
}

function speedMaxForSchema(schema) {
  const max = Number(schema?.max);
  return Number.isFinite(max) && max > 0 ? max : 1;
}

export function clampVfxParam(value, schema) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  if (vfxParamUsesFineSpeedSlider(schema)) {
    return clampMotionRate(n, speedMaxForSchema(schema));
  }
  const min = Number(schema.min);
  const max = Number(schema.max);
  let clamped = n;
  if (Number.isFinite(min)) clamped = Math.max(min, clamped);
  if (Number.isFinite(max)) clamped = Math.min(max, clamped);
  return clamped;
}

export function vfxParamToSliderValue(value, schema) {
  const clamped = clampVfxParam(value, schema);
  if (vfxParamUsesFineSpeedSlider(schema)) {
    return motionSliderFromRate(clamped, speedMaxForSchema(schema));
  }
  return clamped;
}

export function vfxSliderValueToParam(sliderValue, schema) {
  if (vfxParamUsesFineSpeedSlider(schema)) {
    return motionRateFromSlider(sliderValue, speedMaxForSchema(schema));
  }
  return clampVfxParam(sliderValue, schema);
}

export function vfxParamSliderMin(schema) {
  if (vfxParamUsesFineSpeedSlider(schema)) return MOTION_SPEED_SLIDER_MIN;
  return schema.min;
}

export function vfxParamSliderMax(schema) {
  if (vfxParamUsesFineSpeedSlider(schema)) return MOTION_SPEED_SLIDER_MAX;
  return schema.max;
}

export function vfxParamSliderStep(schema) {
  return vfxParamUsesFineSpeedSlider(schema) ? 1 : schema.step;
}

export function formatVfxParamValue(value, schema) {
  const v = clampVfxParam(value, schema);
  if (vfxParamUsesFineSpeedSlider(schema)) {
    return formatMotionSpeedLabel(v, speedMaxForSchema(schema));
  }
  if (Number.isInteger(v)) return String(v);
  return v.toFixed(2);
}
